import { jsx as _jsx } from "react/jsx-runtime";
import useCMSRequest from '../hooks/useCMSRequest';
import CMSContext from './CMSContext';
function CMSContextProvider({ children }) {
    const contentTypesResponse = useCMSRequest('/content_types');
    return _jsx(CMSContext.Provider, { value: { contentTypesResponse }, children: children });
}
export default CMSContextProvider;
